





import Vue from 'vue'

export default Vue.extend({
  name: 'WhatsAppCellRenderer',

  computed: {
    showIcon (): boolean {
      // @ts-ignore
      return false//this.params.data.competence.length > 0
    }
  }
})
